import { Stack } from "@chakra-ui/react";
import NewHireAutoForm from "features/Form/Components/NewHireDynamicForm";
import NewHireHeader from "features/NewHireJourney/Components/NewHireHeader";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import { FormSchema } from "models/autoForm";
import { Task } from "features/Resources/Task/models";
import { useTaskActionContext } from "contexts/TaskActionContext";
import { Text14 } from "components/Text";
import { useMarkCompleteIfOpen } from "../hooks";

interface NewHireInputFormProps {
  task: Task;
  formSchema: FormSchema;
}

export default function NewHireInputForm({ task, formSchema }: NewHireInputFormProps) {
  const { data: newHireJourney } = useNewHireJourneyDetailQuery(task?.newHireJourneyId);
  const { onClose } = useTaskActionContext();
  const markCompleteIfOpen = useMarkCompleteIfOpen(task, onClose);

  return (
    <Stack gap="2">
      <Text14>New Hire</Text14>
      <NewHireHeader newHireJourney={newHireJourney} />
      <NewHireAutoForm
        newHireId={task?.newHireJourneyId}
        formSchema={formSchema}
        onClose={onClose}
        onSuccess={markCompleteIfOpen}
      />
    </Stack>
  );
}
